import React from 'react';
import './AboutPAPT.css';  // Import the corresponding CSS file for styling

const transport = () => {
  return (
    <div className="about-container">
      <div className="content">
        <h1>FOUNDER</h1>
        <div className="yellow-line1"></div>
        <p>
        The objectives of education are closely linked with that of our life. Modern education is classified from Kinder Garten level to specialties and super specialties thus branching out into perfect areas of specialization; education is not meant for acquiring knowledge and information alone but translate them into action and activities for the convenience of man and human race as a whole. As I write this piece disclosure comes of a device to charge mobile batteries by cordless means. Thus goes the thousands of innovations the advance of technology offers to man.

The above relates to the convenience and comforts of living. Thus it satisfies the total or partial need of a person. No doubt people enjoy the fruits of the modern equipment’s and tools. That does not mean he has peace at heart. This is where the lesson of humanities is relevant and important. This is where the religious belief and trust of a person contribute. In short there should be a balance between science and humanities. This lesson is best given as part and parcel of his classroom days. I don’t know how far this liaison is planned in the western countries and those emulating them in our own countries

The best way is to import western technology and export humanities and human values as we see in our culture and belief, thus benefiting both east and west equally.

The best satisfaction in life comes not by increasing the bank balance but offering even part of our belongings to those in need, not by being rough and tough on needless occasions but by being kind and responsive as the need arise.

PAPT is intended to address the human and scientific aspect of modern life. Our institutions inculcate the human values and also equip a person to withstand the tremendous pressure of technological advances, social media and the consequence of becoming a prey and distraction to the contents therein but balancing life and attitude by judicious evaluation and distinction. We are concerned of this trend and are engaged to turn out a worthwhile human being. Our teachers with vast experience and exposure shall ensure model education of your ward.
        </p>
       
      </div> 
      <div className="ed">
      <div style={{ textAlign: "center" }}>
  <img className='chairman-name'
    src="/images/chairman.jpg"
    alt="Chairman"
    // style={{
      
    //   width: "450px",
    //   height: "350px",
    //   objectFit: "cover",
      
      
    // }}
  />
  <p style={{ fontWeight: "bold", fontSize: "18px", margin: "5px 0" }}>
    Late Dr. P A Ibrahim Haji
  </p>
  <p style={{fontWeight:"bold", fontSize: "14px", margin: "0" }}>
    Chairman,
  </p>
  <p style={{ fontSize: "14px", margin: "0" }}>
    P A Educational Trust (Regd.)
  </p>
</div>

      </div>
    </div>
  );
};

export default transport;
